import { lazy } from 'react'
import { pageUrl } from '../services/pageUrl'

export const treasury_routes = [
  // #########################################################################################
  // #############                 TRESORERIE QUOTIDIENNE          ###########################
  // #########################################################################################

  // prévision
  {
    exact: true,
    path: pageUrl.treasury.daily.forecast,
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/forecast/list')
    ),
  },
  {
    exact: true,
    path: '/forecast/new',
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/forecast/fiche')
    ),
  },
  {
    exact: true,
    path: '/forecast/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/forecast/fiche')
    ),
  },
  {
    exact: true,
    path: '/Frm_prevision_auto',
    component: lazy(() =>
      import(
        '../views/menu/treasury/dailytreasury/forecast/prevision_auto/table'
      )
    ),
  },
  {
    exact: true,
    path: '/forecast_auto/new',
    component: lazy(() =>
      import(
        '../views/menu/treasury/dailytreasury/forecast/prevision_auto/fiche'
      )
    ),
  },
  {
    exact: true,
    path: '/forecast_auto/edit/:id',
    component: lazy(() =>
      import(
        '../views/menu/treasury/dailytreasury/forecast/prevision_auto/fiche'
      )
    ),
  },
  {
    exact: true,
    path: '/forecast/temporary',
    component: lazy(() =>
      import(
        '../views/menu/treasury/dailytreasury/forecast/generationTemporaire'
      )
    ),
  },
  {
    exact: true,
    path: '/generation',
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/forecast/generation/index')
    ),
  },

  {
    exact: true,
    path: '/frm_Treso_Ventilation',
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/ventilation/table/index')
    ),
  },

  // cashpool
  {
    exact: true,
    path: pageUrl.treasury.daily.cashpooling,
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/cashpooling')
    ),
  },

  {
    exact: true,
    path: pageUrl.treasury.daily.fiche_valeur,
    component: lazy(() =>
      import(
        '../views/menu/treasury/treasure-quotidienne/fiche-valeur/table/index'
      )
    ),
  },

  // recherche treso
  {
    exact: true,
    path: pageUrl.treasury.daily.search,
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/research/table')
    ),
  },

  // historique
  {
    exact: true,
    path: pageUrl.treasury.daily.rappro_histo,
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/historique')
    ),
  },

  // rapprochement
  {
    exact: true,
    path: pageUrl.treasury.daily.reconciliation,
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/reconciliation/table')
    ),
  },
  {
    exact: true,
    path: '/frm_treso_rappro_details',
    component: lazy(() =>
      import('../views/menu/treasury/dailytreasury/reconciliation/rappro')
    ),
  },

  // #########################################################################################
  // #############                 EVENEMENTS                      ###########################
  // #########################################################################################

  {
    exact: true,
    path: pageUrl.treasury.event.list,
    component: lazy(() =>
      import('../views/menu/treasury/evenement/table/index')
    ),
  },
  {
    exact: true,
    path: '/frm_Evenement/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/evenement/fiche-detail/index')
    ),
  },
  {
    exact: true,
    path: '/frm_Evenement/detail/:id',
    component: lazy(() =>
      import('../views/menu/treasury/evenement/fiche-detail/index')
    ),
  },
  // #########################################################################################
  // #############                 REPORTING                       ###########################
  // #########################################################################################

  // Analyse
  {
    exact: true,
    path: pageUrl.treasury.reporting.analyse,
    component: lazy(() => import('../views/menu/treasury/reporting/analyse')),
  },

  // Analyse Solde
  {
    exact: true,
    path: pageUrl.treasury.reporting.analyseSolde,
    component: lazy(() =>
      import('../views/menu/treasury/reporting/analyseSolde/index')
    ),
  },

  // #########################################################################################
  // #############                 COMPTE COURANT                  ###########################
  // #########################################################################################

  // #########################################################################################
  // #############                GESTION DE LA DETTE              ###########################
  // #########################################################################################

  // #########################################################################################
  // #############                PLACEMENT                        ###########################
  // #########################################################################################
  {
    exact: true,
    path: pageUrl.treasury.placement.valueGestion.liste,
    component: lazy(() =>
      import('../views/menu/treasury/placement/value_gestion/table/index')
    ),
  },
  {
    exact: true,
    path: '/frm_PlctValeur/visualise/:id',
    component: lazy(() =>
      import(
        '../views/menu/treasury/placement/value_gestion/visuaalise-cours/table/index'
      )
    ),
  },

  // #########################################################################################
  // #############                 ADMINISTRATION                  ###########################
  // #########################################################################################

  // #########################################################################################
  // #############                 COMPTE COURANT                  ###########################
  // #########################################################################################
  // list
  {
    exact: true,
    path: pageUrl.treasury.currentAccount.list,
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/list/table')
    ),
  },
  {
    exact: true,
    path: '/current_account/statement/:id',
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/list/releves')
    ),
  },
  {
    exact: true,
    path: '/current_account/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/list/fiche')
    ),
  },
  {
    exact: true,
    path: '/current_account/history/:id',
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/list/historique')
    ),
  },
  {
    exact: true,
    path: '/current_account/new',
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/list/fiche')
    ),
  },

  // calcul
  {
    exact: true,
    path: pageUrl.treasury.currentAccount.calculation,
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/calculation/table')
    ),
  },

  // Analyse
  {
    exact: true,
    path: pageUrl.treasury.currentAccount.analyse,
    component: lazy(() =>
      import('../views/menu/treasury/currentaccount/Analyse')
    ),
  },

  // #########################################################################################
  // #############                GESTION DE LA DETTE              ###########################
  // #########################################################################################

  // #########################################################################################
  // #############                PLACEMENT                        ###########################
  // #########################################################################################

  // #########################################################################################
  // #############                 ADMINISTRATION                  ###########################
  // #########################################################################################
  // #########################################################################################
  // #############                 PARAMETRAGE                     ###########################
  // #########################################################################################

  {
    exact: true,
    path: pageUrl.treasury.settings.rate,
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/reference/table/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/detail/:id',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/reference/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/reference/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/detail/taux/:id',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/reference/details/table/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/new',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/reference/fiche/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.settings.remunerationCondition,
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/personnalisation/table/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/personnalisation/detail/:id',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/personnalisation/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/personnalisation/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/personnalisation/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/valeurtaux/personnalisation/new',
    component: lazy(() =>
      import('../views/menu/treasury/valeurtaux/personnalisation/fiche/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.treasury.settings.analyticsCode,
    component: lazy(() =>
      import('../views/menu/treasury/settings/natural-code/table')
    ),
  },
  {
    exact: true,
    path: '/analytic_code/group-code-nature',
    component: lazy(() =>
      import(
        '../views/menu/treasury/settings/natural-code/groupe-code-account/table/index'
      )
    ),
  },
  {
    exact: true,
    path: '/analytic_code/group-code-nature/:id',
    component: lazy(() =>
      import(
        '../views/menu/treasury/settings/natural-code/groupe-code-account/fiche/index'
      )
    ),
  },
  {
    exact: true,
    path: '/analytic_code/group-code-nature/new',
    component: lazy(() =>
      import(
        '../views/menu/treasury/settings/natural-code/groupe-code-account/fiche/index'
      )
    ),
  },
  {
    exact: true,
    path: '/analytic_code/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/natural-code/fiche')
    ),
  },
  {
    exact: true,
    path: '/analytic_code/new',
    component: lazy(() =>
      import('../views/menu/treasury/settings/natural-code/fiche')
    ),
  },
  {
    exact: true,
    path: '/analytic_codee/detail/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/natural-code/fiche')
    ),
  },

  {
    exact: true,
    path: pageUrl.treasury.settings.accountGroup,
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/table')
    ),
  },
  {
    exact: true,
    path: '/account_group/edit/:ref/:id/',
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/fiche')
    ),
  },
  {
    exact: true,
    path: '/account_group/type/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/fiche-type')
    ),
  },
  {
    exact: true,
    path: '/account_group/detail/:ref/:id/',
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/fiche')
    ),
  },
  {
    exact: true,
    path: '/account_group/type/detail/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/fiche-type')
    ),
  },
  {
    exact: true,
    path: '/account_group/new',
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/fiche')
    ),
  },
  {
    exact: true,
    path: '/account_group/type/new',
    component: lazy(() =>
      import('../views/menu/treasury/settings/account-group/fiche-type')
    ),
  },
  // treasury reports (Etats)
  {
    exact: true,
    path: pageUrl.treasury.settings.reports,
    component: lazy(() =>
      import('../views/menu/treasury/settings/reports/table')
    ),
  },
  {
    exact: true,
    path: '/report/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/reports/fiche')
    ),
  },
  {
    exact: true,
    path: '/report/detail/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/reports/fiche')
    ),
  },
  {
    exact: true,
    path: '/report/new',
    component: lazy(() =>
      import('../views/menu/treasury/settings/reports/fiche')
    ),
  },
  // treasury rules
  {
    exact: true,
    path: '/treasury_rule',
    component: lazy(() =>
      import('../views/menu/treasury/settings/treasury-regle/table')
    ),
  },
  {
    exact: true,
    path: '/treasury_rule/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/settings/treasury-regle/fiche')
    ),
  },
  {
    exact: true,
    path: '/treasury_rule/new',
    component: lazy(() =>
      import('../views/menu/treasury/settings/treasury-regle/fiche')
    ),
  },
  // treasury debt
  {
    exact: true,
    path: pageUrl.treasury.debt,
    component: lazy(() => import('../views/menu/treasury/debt/list')),
  },
  {
    exact: true,
    path: pageUrl.treasury.analyse_dette,
    component: lazy(() =>
      import('../views/menu/treasury/debt/analyse-dette-graph/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.emprunt,
    component: lazy(() => import('../views/menu/treasury/emprunt/table/index')),
  },
  {
    exact: true,
    path: pageUrl.treasury.payementEmprunt,
    component: lazy(() =>
      import('../views/menu/treasury/payement/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.payement,
    component: lazy(() =>
      import('../views/menu/treasury/payement/table/index')
    ),
  },
  {
    exact: true,
    path: '/treasury/credit-line/new',
    component: lazy(() => import('../views/menu/treasury/debt/fiche')),
  },
  {
    exact: true,
    path: '/treasury/emprunt/new',
    component: lazy(() => import('../views/menu/treasury/debt/fiche')),
  },
  {
    exact: true,
    path: '/treasury/emprunt/:id',
    component: lazy(() => import('../views/menu/treasury/debt/fiche')),
  },

  {
    exact: true,
    path: '/treasury/emprunt/:debtId/timeline/:id',
    component: lazy(() => import('../views/menu/treasury/debt/detail')),
  },
  {
    exact: true,
    path: '/treasury/credit-line/:id',
    component: lazy(() => import('../views/menu/treasury/debt/fiche')),
  },
  {
    exact: true,
    path: '/treasury/credit-line/:debtId/timeline/:id',
    component: lazy(() => import('../views/menu/treasury/debt/detail')),
  },
  {
    exact: true,
    path: pageUrl.treasury.consultationDette,
    component: lazy(() =>
      import('../views/menu/treasury/debt_consultation/index')
    ),
  },
  // treasury etablissement externe/compte bancaire
  {
    exact: true,
    path: '/establishment/bank-account',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/table')
    ),
  },
  {
    exact: true,
    path: '/establishment/bank-account/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/establishment/bank-account/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: '/establishment/bank-account/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/account/fiche/New/index')
    ),
  },
  // etablish externe
  {
    exact: true,
    path: pageUrl.treasury.settings.etablishExterne,
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/table')
    ),
  },
  {
    exact: true,
    path: '/establishment/detail/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/establishment/edit/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/New/index')
    ),
  },
  {
    exact: true,
    path: '/4eyes_validation/establishment/:request_id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/Validation/index')
    ),
  },
  {
    exact: true,
    path: '/establishment/history/:id',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/history')
    ),
  },
  {
    exact: true,
    path: '/establishment/new',
    component: lazy(() =>
      import('../views/menu/cash/referentiel/company/fiche/New/index')
    ),
  },

  {
    exact: true,
    path: pageUrl.treasury.placement.compteTitre.liste,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTitre/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteTitre.vizualise,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTitre/vizualise/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteTitre.fiche,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTitre/fiche/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.treasury.placement.compteTitre.edit}:id`,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTitre/fiche/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteTerme.liste,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTerme/table/index')
    ),
  },
  {
    exact: true,
    path: '/treasury/placement/:debtId/frm_CAT/:id',
    component: lazy(() => import('../views/menu/treasury/debt/detail')),
  },
  {
    exact: true,
    path: `${pageUrl.treasury.placement.compteTerme.edit}:id`,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTitre/fiche/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteTerme.fiche,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTitre/fiche/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteTerme.payement,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteTerme/payement/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.consultationPlct,
    component: lazy(() =>
      import('../views/menu/treasury/placement/consultation/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.analysePlct,
    component: lazy(() =>
      import('../views/menu/treasury/placement/analyse-placement-graph/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteRemunerer.liste,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteRemunerer/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteRemunerer.create,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteRemunerer/fiche/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.treasury.placement.compteRemunerer.edit}:id`,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteRemunerer/fiche/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.treasury.placement.compteRemunerer.visualisation}/:id`,
    component: lazy(() =>
      import(
        '../views/menu/treasury/placement/compteRemunerer/visualisation/index'
      )
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteCapi.liste,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteCapital/table/index')
    ),
  },
  {
    exact: true,
    path: pageUrl.treasury.placement.compteCapi.create,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteCapital/fiche/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.treasury.placement.compteCapi.edit}:id`,
    component: lazy(() =>
      import('../views/menu/treasury/placement/compteCapital/fiche/index')
    ),
  },
  {
    exact: true,
    path: `${pageUrl.treasury.placement.compteCapi.visualisation}:id`,
    component: lazy(() =>
      import(
        '../views/menu/treasury/placement/compteCapital/visualisation/index'
      )
    ),
  },
  // #########################################################################################
  // #############                 BUDGET                    ###########################
  // #########################################################################################

  {
    exact: true,
    path: '/budget_scenario',
    component: lazy(() =>
      import('../views/menu/treasury/budget/scenario/table/index')
    ),
  },
  {
    exact: true,
    path: '/budget_scenario/edit/:id',
    component: lazy(() =>
      import('../views/menu/treasury/budget/scenario/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/budget_scenario/new',
    component: lazy(() =>
      import('../views/menu/treasury/budget/scenario/fiche/index')
    ),
  },
  {
    exact: true,
    path: '/budget_analysis',
    component: lazy(() =>
      import('../views/menu/treasury/budget/analyse/Analyse')
    ),
  },

  {
    exact: true,
    path: '/budget_scenario/visualise/:id',
    component: lazy(() =>
      import('../views/menu/treasury/budget/scenario/visualiser/table/index')
    ),
  },
]

